import { render, staticRenderFns } from "./AccessibilityToolbar.vue?vue&type=template&id=2b0c64f8&scoped=true"
import script from "./AccessibilityToolbar.vue?vue&type=script&lang=js"
export * from "./AccessibilityToolbar.vue?vue&type=script&lang=js"
import style0 from "./AccessibilityToolbar.vue?vue&type=style&index=0&id=2b0c64f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0c64f8",
  null
  
)

export default component.exports